import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";

const ReportPDFEmailForm = ({}) => {
    return(
        <>
        <StyledGridRow>
            <StyledGridCol xs={24}>
                <FormItem label="From">
                  <TextField/>
                </FormItem>
            </StyledGridCol>
            <StyledGridCol xs={24}>
                <FormItem label="To">
                  <TextField/>
                </FormItem>
            </StyledGridCol>
            <StyledGridCol xs={24}>
                <FormItem label="Subject">
                  <TextField/>
                </FormItem>
            </StyledGridCol>
            <StyledGridCol xs={24}>
                <FormItem label="Body">
                  <TextField inputType="textarea"/>
                </FormItem>
            </StyledGridCol>
        </StyledGridRow>
        </>
    )
}
export default ReportPDFEmailForm;